import styled from '@emotion/styled';

interface ICarouselItemProps {
	children?: React.ReactNode;
	className?: string;
	ariaSlideIndex: number;
	ariaTotalNumberOfSlides: number;
	ariaSlideTitle: string;
}

export function CarouselItem({
	children,
	className,
	ariaSlideIndex,
	ariaTotalNumberOfSlides,
	ariaSlideTitle,
	...rest
}: ICarouselItemProps) {
	const current = ariaSlideIndex + 1;
	const total = ariaTotalNumberOfSlides;
	const title = ariaSlideTitle;

	return (
		<StyledCarouselItem
			className={className}
			{...rest}
			data-carousel-card
			role="group"
			aria-roledescription="slide"
			aria-label={`Slide ${current} of ${total}: ${title}`}
		>
			{children}
		</StyledCarouselItem>
	);
}

export const StyledCarouselItem = styled.li`
	list-style: none;
	padding: 0;
	margin: 0;
	display: flex;

	/* Prevent drag interference */
	user-select: none;
`;
